module.exports = __webpack_public_path__ + "img/ico-preview.581d7e56.svg";